import { NfseRoles } from "src/app/pages/nfse/models/nfse-roles";

export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype?: string;
  collapse?: string;
  children?: ChildrenItems[];
  role?: string;
}

export interface ChildrenItems {
  path: string;
  title: string;
  icontype?: string;
  ab?: string;
  type?: string;
  collapse?: string;
  children?: ChildrenItems[];
  role?: string;
}

//Menu Items
export const ROUTES_SIDEBAR: RouteInfo[] = [
  {
    path: "/auditoriaDETRAN",
    title: "DETRAN",
    type: "sub",
    icontype: "local_police",
    collapse: "detran",
    role: "detranService_edit",
    children: [
      {
        path: "vistorias-criticas",
        title: "- VISTORIAS CRÍTICAS",
        role: "detranService_edit",
      },
    ],
  },
  {
    path: "/home",
    title: "HOME",
    type: "link",
    icontype: "home",
    role: "dashboard",
  },
  {
    path: "/cadastro",
    title: "CADASTROS",
    type: "sub",
    icontype: "queue",
    collapse: "cadastro",
    role: "cadastro",
    children: [
      { path: "ecv", title: "- ECV", role: "ecv" },
      { path: "grupoecv", title: "- FILIAL", role: "grupoecv" },
      { path: "usuario", title: "- USUÁRIOS", role: "usuario" },
      {
        path: "clientes",
        title: "- CLIENTES / FORNECEDOR",
        role: "clientes",
      },
    ],
  },
  {
    path: "/operacao",
    title: "VISTORIAS",
    type: "sub",
    icontype: "content_paste",
    collapse: "operacao",
    role: "operacao",
    children: [
      { path: "agenda", title: "- AGENDA", role: "agendamento" },
      {
        path: "bancoDeImagens",
        title: "- CONSULTAR CHASSI/MOTOR",
        role: "imageBank",
      },
      { path: "consultaWS", title: "- CONSULTAR DETRAN", role: "consultaWS" },
      { path: "vistorias", title: "- CONSULTAR VISTORIAS", role: "vistorias" },
    ],
  },
  {
    path: "/nfse",
    title: "NOTA FISCAL",
    type: "sub",
    icontype: "receipt_long",
    collapse: "nfse",
    role: NfseRoles.NFSE,
    children: [
      { path: "consultar-nfse", title: "- CONSULTAR NFS-e", role: NfseRoles.NFSE },
      { path: "relatorio-nfse", title: "- RELATÓRIO", role: NfseRoles.NFSE },
    ],
  },
  {
    path: "/dashboard-financeiro",
    title: "DASHBOARD FINANCEIRO",
    type: "link",
    icontype: "attach_money",
  },
  {
    path: "/credito",
    title: "CRÉDITOS",
    type: "sub",
    icontype: "monetization_on",
    collapse: "credito",
    role: "view_credits",
    children: [
      {
        path: "consultarCreditos",
        title: "- CONSULTAR CRÉDITOS",
        role: "view_credits",
      },
    ],
  },
  {
    path: "/suporte",
    title: "MESA DE ANÁLISE",
    type: "sub",
    icontype: "photo_library",
    collapse: "mesa",
    role: "desk_vistoria",
    children: [
      // {
      //   path: "desk_vistoria",
      //   title: "- IMAGENS/FILMAGENS",
      //   role: "desk_vistoria",
      // },
      {
        path: "estatisticas",
        title: "- ESTATÍSTICAS",
        role: "desk_vistoria",
      },
      {
        path: "relatorio-ocr",
        title: "- RELATÓRIO OCR",
        role: "desk_vistoria",
      },
      {
        path: "analise",
        title: "- ANÁLISE OCR",
        role: "desk_vistoria",
      },
      {
        path: "desk_finance",
        title: "- MESA DE PAGAMENTO",
        role: "desk_finance",
      },
    ],
  },
  // {
  //   path: "/financeiro",
  //   title: "FINANÇAS",
  //   type: "sub",
  //   icontype: "attach_money",
  //   collapse: "financeiro",
  //   role: "financas",
  //   children: [
  //     { path: "contasapagar", title: "- CONTAS A PAGAR", role: "clientesECV" },
  //     { path: "contasareceber", title: "- CONTAS A RECEBER", role: "financas" },
  //     {
  //       path: "relatoriosfinanceiro",
  //       title: "- RELATÓRIOS ",
  //       role: "clientes",
  //     },
  //   ],
  // },
  // {
  //   path: "/auditoriaDETRAN",
  //   title: "AUDITORIA DETRAN",
  //   type: "sub",
  //   icontype: "location_searching",
  //   collapse: "auditoriDetran",
  //   role: "financeiro",
  //   children: [
  //     { path: "relatoriosauditoria", title: "- RELATÓRIOS ", role: "clientes" },
  //   ],
  // },
  // {
  //   path: "/comercial",
  //   title: "FINANCEIRO/COMERCIAL",
  //   type: "sub",
  //   icontype: "phone_android",
  //   collapse: "financeiroComercial",
  //   role: "financeiro",
  //   children: [
  //     { path: "medicao", title: "- MEDIÇÃO", role: "clientes" },
  //     { path: "dashboard", title: "- DASHBOARD", role: "dashboard" },
  //     {
  //       path: "faturarmensal",
  //       title: "- FATURAR MENSAL",
  //       role: "gerenciamentoDeCredito",
  //     },
  //     {
  //       path: "relatorioscomercial",
  //       title: "- RELATORIOS",
  //       role: "clientesECV",
  //     },
  //   ],
  // },
  // {
  //   path: "/financeiro",
  //   title: "CRM",
  //   type: "sub",
  //   icontype: "dvr",
  //   collapse: "crm",
  //   role: "financeiro",
  //   children: [],
  // },
  {
    path: "/suporte",
    title: "SUPORTE SERV DESK",
    type: "sub",
    icontype: "settings",
    collapse: "suporte",
    role: "suporte",
    children: [
      { path: "auditoria", title: "- AUDITORIA", role: "auditoria" },
      { path: "suporteN2", title: "- SUPORTE N2", role: "suporteN2" },
      { path: "ecv-sombra", title: "- ECV SOMBRA", role: "ecv_read" },
      {
        path: "xml-detran",
        title: "- RETORNOS XML DETRAN",
        role: "desk_vistoria",
      },
      {
        path: "historico-ocr",
        title: "- HISTÓRICO OCR",
        role: "desk_vistoria",
      },
      { path: "healthcheck", title: "- HEALTHCHECK", role: "suporte" },
    ],
  },
  {
    path: "/gerenciamento",
    title: "SUPORTE DEV",
    type: "sub",
    icontype: "devices",
    collapse: "gerenciamento",
    role: "gerenciamento",
    children: [
      {
        path: "codigodetran",
        title: "- CONSULTAR CÓDIGO DETRAN",
        role: "codigodetran",
      },
      {
        path: "itensdereprovacao",
        title: "- CONSULTAR ITENS DE REPROVAÇÃO",
        role: "itensdereprovacao",
      },
      {
        path: "parametros",
        title: "- CONSULTAR PARÂMETROS",
        role: "parametros",
      },
      {
        path: "servicodetran",
        title: "- CONSULTAR SERVIÇO DETRAN",
        role: "servicodetran",
      },
      {
        path: "mensagemDeAlerta",
        title: "- MENSAGEM DE ALERTA",
        role: "mensagemDeAlerta",
      },
      { path: "midia", title: "- TIPOS DE MÍDIAS", role: "grupoecv" },
    ],
  },
  //   {
  //     path: "/ajuda",
  //     title: "AJUDA",
  //     type: "sub",
  //     icontype: "help_outline",
  //     collapse: "ajuda",
  //     role: "ajuda",
  //     children: [{ path: "manuais", title: "MANUAIS", role: "manuais" }],
  //   },
];
